/**
 * Subdomain Detection Utility
 * Detects which subdomain user is on and returns role
 * Also supports URL query parameter for PWA mode
 */

export const detectRole = () => {
  // Priority 1: Check URL query parameter (for PWA installed apps)
  const urlParams = new URLSearchParams(window.location.search);
  const roleParam = urlParams.get('role');
  
  if (roleParam === 'admin' || roleParam === 'handler' || roleParam === 'customer') {
    console.log('🎯 Role detected from URL parameter:', roleParam);
    return roleParam;
  }
  
  // Priority 2: Check hostname (for subdomain access)
  const hostname = window.location.hostname;
  
  if (hostname.includes('handler.')) {
    console.log('🎯 Role detected from subdomain: handler');
    return 'handler';
  } else if (hostname.includes('admin.')) {
    console.log('🎯 Role detected from subdomain: admin');
    return 'admin';
  } else {
    console.log('🎯 Role detected: customer (default)');
    return 'customer'; // default for dwsvault.app, app.dwsvault.app, www.dwsvault.app
  }
};

export const getDefaultRoute = (role) => {
  const routes = {
    'customer': '/',
    'handler': '/handler-login',
    'admin': '/admin-login'
  };
  
  return routes[role] || '/';
};

export const shouldRedirect = (currentPath, role) => {
  // Don't redirect if already on correct page
  if (role === 'handler' && currentPath.includes('handler')) return false;
  if (role === 'admin' && currentPath.includes('admin')) return false;
  if (role === 'customer' && currentPath === '/') return false;
  
  // Redirect if on wrong login page for subdomain
  if (role === 'handler' && !currentPath.includes('handler')) return true;
  if (role === 'admin' && !currentPath.includes('admin')) return true;
  
  return false;
};
